import onetimeIcon from './../../../../styles/images/onetime-icon.svg'
import contractIcon from './../../../../styles/images/contract-icon.svg'
import recurringIcon from './../../../../styles/images/recurring-icon.svg'
import { NavLink } from 'react-router-dom'
import { ArrowRightOutlined } from '@ant-design/icons'

export function NewBookingType() {
  return (
    <div className='site-page'>
      <div className='site-page-header'></div>
      <div className='new-booking-type-body'>
        <div className='label'>Create New Booking</div>
        <div className='label-description'>Choose the type of booking you want to create</div>
        <div className='select-booking-container'>
          <NavLink to='/schedule/one-time-booking' className='wrapper'>
            <div className='left-decoration onetime-bg'></div>
            <div className='icon-container onetime-bg'>
              <img alt='one-time-booking' src={onetimeIcon} className='left-icon' />
            </div>
            <div className='sub-label'>One-Time Booking</div>
            <div style={{ color: '#6B7280', fontWeight: 400 }}>
              Schedule a single service appointment for a specific date and time
            </div>
            <div className={'create-booking-link'}>
              Create Booking
              <ArrowRightOutlined />
            </div>
          </NavLink>
          <NavLink to='/schedule/contract-booking' className='wrapper'>
            <div className='left-decoration contract-bg'></div>
            <div className='icon-container contract-bg'>
              <img alt='avatar' src={contractIcon} className='left-icon' />
            </div>
            <div className='sub-label'>Contract Booking</div>
            <div style={{ color: '#6B7280', fontWeight: 400 }}>
              For long-term packages with several visits spread over months
            </div>
            <div className={'create-booking-link'}>
              Create Booking
              <ArrowRightOutlined />
            </div>
          </NavLink>
          <NavLink to='/schedule/recurring-booking' className='wrapper'>
            <div className='left-decoration recurring-bg'></div>
            <div className='icon-container recurring-bg'>
              <img alt='avatar' src={recurringIcon} className='left-icon' />
            </div>
            <div className='sub-label'>Recurring Booking</div>
            <div style={{ color: '#6B7280', fontWeight: 400 }}>
              Set up regular appointments with automated scheduling and billing
            </div>
            <div className={'create-booking-link'}>
              Create Booking
              <ArrowRightOutlined />
            </div>
          </NavLink>
        </div>
      </div>
    </div>
  )
}
